module.exports = __webpack_public_path__ + "img/blessing_prize_6.651eb6f4.png";